/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { groupBy } from 'lodash';
import { UsePortalDispatch } from '../../../../Store';
import { useAccessories, useQuoteAccessories } from '../../../../Store/entities/accessories/hooks';
import Button from '../../../../Parts/Button';
import { Accessory } from '../../../../powershadesApiTypes';
import AccessoriesAccordion from './AccessoriesAccordion';
import { useIsPsAdmin } from '../../../../hooks';
import { useQuoteTypeNameByQuoteId } from '../../../../Store/entities/quotes/hooks';
import { updateQuoteAccessories } from '../../../../Store/entities/accessories';

type NewAccessoryFormProps = {
	quoteId: number;
	onDone: () => void;
};

const NewAccessoryForm = ({ quoteId, onDone }: NewAccessoryFormProps) => {
	const dispatch = UsePortalDispatch();

	const isAdmin = useIsPsAdmin();
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const quoteAccessories = useQuoteAccessories(quoteId);
	const accessories = useAccessories(quoteId);

	const fromStoreSelectedAccessories = quoteAccessories.map((acc) => {
		const accessory = accessories.find((a) => a.part_number === acc.part_number);
		return {
			accessory: accessory ?? ({ part_number: acc.part_number } as Accessory),
			quantity: acc.quantity
		};
	});

	const [selectedAccessories, setSelectedAccessories] = useState(fromStoreSelectedAccessories);

	const groupedAccessories = groupBy(
		accessories
			?.sort((a, b) => a?.name?.toLowerCase().localeCompare(b?.name?.toLowerCase()))
			.filter((a) => a.is_active)
			.filter((a) => !a.is_internal_only || isAdmin),
		'category'
	);

	const handleClose = useCallback(() => {
		const accessorriesToUpdate = selectedAccessories.map((acc) => ({
			quantity: acc.quantity,
			part_number: acc.accessory.part_number ?? "",
			name: acc.accessory.name ?? "",
		}));

		dispatch(updateQuoteAccessories({
			quote_id: quoteId,
			quote_accessories: accessorriesToUpdate
		}));

		onDone();
	}, [accessories, quoteAccessories, selectedAccessories]);
	if ((accessories ?? []).length === 0) {
		return (
			<Container style={{ minHeight: "400px", justifyContent: "start" }}>
				<h2 className={`text-${quoteType}`}>Add Accessories</h2>
				<p>No accessories available.</p>
			</Container>
		);
	}

	return (
		<Container style={{ minHeight: "400px", justifyContent: "start" }}>
			<h2 className={`text-${quoteType}`}>Add Accessories</h2>
			<AccessoriesAccordion
				accessories={groupedAccessories}
				selectedAccessories={selectedAccessories}
				setSelectedAccessories={setSelectedAccessories}
				quoteId={quoteId}
			/>
			<Container className="local-bootstrap mt-auto">
				<Row className="mt-4 mb-2 justify-content-end">
					<Col xl={4} className="text-end">
						<Button fullWidth color={quoteType ?? 'green'} onClick={handleClose}>
							Done
						</Button>
					</Col>
				</Row>
			</Container>
		</Container>
	);
};

export default NewAccessoryForm;
